import { Breadcrumb } from 'components/Breadcrumb';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MdOutlineClose } from 'react-icons/md';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { ApplicationState } from 'store/store.inteface';
import { clearAllSteps, recoverDraft } from 'store/modules/openClaim/actions';
import { ROLES } from 'config/roles';
import Skeleton from 'react-loading-skeleton';
import { getTrfRemAction } from 'store/modules/claims/actions';
import { Button } from '@grupoboticario/flora-react';
import { Container, Content, Title, Header } from './styles';
import {
  Card01,
  Card02,
  Card03,
  Card04,
  Card05,
  Card06,
  Card07,
  Card08,
} from '../../Franchisee/OpenClaim/Step5/cards';

export const ClaimProcess = (): JSX.Element => {
  const { id } = useParams();
  const history = useHistoryWithHost();
  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  const { trfRem } = useSelector((state: ApplicationState) => state.claims);
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  const { rolesList } = useSelector((state: ApplicationState) => state.roles);
  const [recovered, setRecovered] = useState(false);

  const isManagement = rolesList[0] === ROLES.MANAGEMENT;
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      (id && !recovered && stores.length > 0) ||
      (id && !recovered && isManagement)
    ) {
      // existe id mas nao recuperou um rascunho ainda
      dispatch(recoverDraft(id));
      setRecovered(true);
    }
  }, [id]);

  useEffect(() => {
    return () => {
      dispatch(clearAllSteps());
    };
  }, []);

  useEffect(() => {
    if (id && isManagement) {
      dispatch(getTrfRemAction(id));
    }
  }, [id]);

  return (
    <Container>
      <Breadcrumb color="light" />
      {stateClaim.finalId ? (
        <Content>
          <Header>
            <Title>Sinistro: #{stateClaim.finalId}</Title>
            <Button
              size="small"
              styleSemantic="success"
              className="first"
              onClick={() => {
                history.goBack();
              }}
              has="iconRight"
              icon={<MdOutlineClose />}
            >
              Fechar
            </Button>
          </Header>
          <Card01 stateClaim={stateClaim} />
          <Card02 stateClaim={stateClaim} />
          <Card03 stateClaim={stateClaim} />
          <Card04 stateClaim={stateClaim} />
          <Card05 stateClaim={stateClaim} />
          <Card06 stateClaim={stateClaim} />
          {isManagement && <Card08 trfRem={trfRem} />}
          <Card07 stateClaim={stateClaim} />
          <Button
            size="small"
            styleSemantic="success"
            className="last"
            has="iconRight"
            icon={<MdOutlineClose />}
            onClick={() => {
              history.goBack();
            }}
          >
            Fechar
          </Button>
        </Content>
      ) : (
        <Content>
          <Header>
            <Skeleton height={500} count={30} />
          </Header>
        </Content>
      )}
    </Container>
  );
};
